import axios from 'axios';

console.log('🔗 API_URL:', process.env.REACT_APP_API_URL);

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

console.log('🌐 Using API_URL:', API_URL);

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token automatiquement
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Clubs API
// Clubs API avec géolocalisation
export const getAllClubs = async (userLocation = null) => {
  let url = '/clubs';
  
  if (userLocation && userLocation.latitude && userLocation.longitude) {
    url += `?lat=${userLocation.latitude}&lon=${userLocation.longitude}`;
  }
  
  const response = await api.get(url);
  return response.data;
};

export const getClubById = async (id) => {
  const response = await api.get(`/clubs/${id}`);
  return response.data;
};

export const getClubsByUser = async (userId) => {
  const response = await api.get(`/users/${userId}/clubs`);
  return response.data;
};

export const createClub = async (clubData) => {
  const response = await api.post('/clubs', clubData);
  return response.data;
};

export const joinClub = async (id) => {
  const response = await api.post(`/clubs/${id}/join`);
  return response.data;
};

export const getSeanceParticipants = async (clubId, seanceId, date) => {
  const response = await api.get('/users/calendar/participants', {
    params: { clubId, seanceId, date }
  });
  return response.data;
};

export const leaveClub = async (id) => {
  const response = await api.post(`/clubs/${id}/leave`);
  return response.data;
};

export const getMyClubs = async () => {
  const response = await api.get('/clubs/user/my-clubs');
  return response.data;
};

export const getMyCreatedClubs = async () => {
  const response = await api.get('/clubs/user/created');
  return response.data;
};

export const updateClub = async (id, clubData) => {
  const response = await api.put(`/clubs/${id}`, clubData);
  return response.data;
};

export const deleteClub = async (id) => {
  const response = await api.delete(`/clubs/${id}`);
  return response.data;
};

// Users API
export const getProfile = async () => {
  const response = await api.get('/users/profile');
  return response.data;
};

export const updateProfile = async (profileData) => {
  const response = await api.put('/users/profile', profileData);
  return response.data;
};

export const changePassword = async (passwordData) => {
  const response = await api.put('/users/change-password', passwordData);
  return response.data;
};

export const getUserById = async (id) => {
  const response = await api.get(`/users/${id}`);
  return response.data;
};

// Search API
export const searchClubs = async (query) => {
  const response = await api.get(`/clubs/search?q=${encodeURIComponent(query)}`);
  return response.data;
};

export const searchUsers = async (query) => {
  const response = await api.get(`/users/search?q=${encodeURIComponent(query)}`);
  return response.data;
};

// Following/Followers API
export const followUser = async (userId) => {
  const response = await api.post(`/users/${userId}/follow`);
  return response.data;
};

export const unfollowUser = async (userId) => {
  const response = await api.post(`/users/${userId}/unfollow`);
  return response.data;
};

export const getFollowers = async (userId) => {
  const response = await api.get(`/users/${userId}/followers`);
  return response.data;
};

export const transferOwnership = async (clubId, newOwnerId) => {
  const response = await api.put(`/clubs/${clubId}/transfer-ownership`, { newOwnerId });
  return response.data;
};

export const getFollowingClubs = async () => {
  const response = await api.get('/clubs/following-clubs');
  return response.data;
};

export const getFollowing = async (userId) => {
  const response = await api.get(`/users/${userId}/following`);
  return response.data;
};

export const isFollowing = async (userId) => {
  console.log(userId);
  const response = await api.get(`/users/${userId}/is-following`);  // fuck ici
  console.log(response);
  console.log(response.data);
  return response.data;
};

// VDOT API
export const updateVDOT = async (distance, temps) => {
  const response = await api.put('/users/update-vdot', { distance, temps });
  return response.data;
};

export const updatePacesVisibility = async (visible) => {
  const response = await api.put('/users/paces-visibility', { visible });
  return response.data;
};

export const getRecommendedClubs = async () => {
  const response = await api.get('/users/recommended-clubs');
  return response.data;
};

// ========== CALENDRIER API (NOUVELLES FONCTIONS) ==========

// Ajouter une séance au calendrier
export const addSeanceToCalendar = async (clubId, seanceIndex, seanceData, date) => {
  const response = await api.post('/users/calendar/add-seance', {
    clubId,
    seanceIndex,
    seanceData,
    date // NOUVEAU paramètre
  });
  return response.data;
};

// Obtenir le calendrier de l'utilisateur
export const getCalendar = async () => {
  const response = await api.get('/users/calendar');
  return response.data;
};

// Annuler une séance
export const cancelSeance = async (seanceCalendrierId) => {
  const response = await api.put(`/users/calendar/cancel-seance/${seanceCalendrierId}`);
  return response.data;
};

// Réactiver une séance annulée
export const reactivateSeance = async (seanceCalendrierId) => {
  const response = await api.put(`/users/calendar/reactivate-seance/${seanceCalendrierId}`);
  return response.data;
};

// Supprimer une séance du calendrier
export const removeSeanceFromCalendar = async (seanceCalendrierId) => {
  const response = await api.delete(`/users/calendar/remove-seance/${seanceCalendrierId}`);
  return response.data;
};

// Ajouter ces fonctions
export const createPost = async (clubId, contenu, typePost) => {
  const response = await api.post('/posts', { clubId, contenu, typePost });
  return response.data;
};

export const getPostsByClub = async (clubId) => {
  const response = await api.get(`/posts/club/${clubId}`);
  return response.data;
};

export const deletePost = async (postId) => {
  const response = await api.delete(`/posts/${postId}`);
  return response.data;
};

// ==================== UPDATE LOGS ====================
// Ajouter ces fonctions à la fin de ton fichier src/services/api.js

// Obtenir tous les updates publics
export const getUpdates = async () => {
  try {
    const response = await api.get('/updates');
    return response.data;
  } catch (error) {
    console.error('Erreur getUpdates:', error);
    throw error;
  }
};

// Obtenir un update par ID
export const getUpdateById = async (id) => {
  try {
    const response = await api.get(`/updates/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erreur getUpdateById:', error);
    throw error;
  }
};

// ==================== ADMIN UPDATE LOGS ====================

// Obtenir tous les updates (admin - incluant invisibles)
export const getUpdatesAdmin = async () => {
  try {
    const response = await api.get('/updates/admin/all');
    return response.data;
  } catch (error) {
    console.error('Erreur getUpdatesAdmin:', error);
    throw error;
  }
};

// Créer un nouveau update (admin)
export const createUpdate = async (updateData) => {
  try {
    const response = await api.post('/updates/admin', updateData);
    return response.data;
  } catch (error) {
    console.error('Erreur createUpdate:', error);
    throw error;
  }
};

// Mettre à jour un update (admin)
export const updateUpdate = async (id, updateData) => {
  try {
    const response = await api.put(`/updates/admin/${id}`, updateData);
    return response.data;
  } catch (error) {
    console.error('Erreur updateUpdate:', error);
    throw error;
  }
};

// Supprimer un update (admin)
export const deleteUpdate = async (id) => {
  try {
    const response = await api.delete(`/updates/admin/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erreur deleteUpdate:', error);
    throw error;
  }
};

// Basculer la visibilité d'un update (admin)
export const toggleUpdateVisibility = async (id) => {
  try {
    const response = await api.patch(`/updates/admin/${id}/toggle-visibility`);
    return response.data;
  } catch (error) {
    console.error('Erreur toggleUpdateVisibility:', error);
    throw error;
  }
};

export const getStravaActivities = async () => {
  try {
    const response = await api.get('/strava/activities');
    return response.data;
  } catch (error) {
    console.error('Erreur getStravaActivities:', error);
    throw error;
  }
};

export const syncStravaActivity = async (activityId, challengeId) => {
  try {
    const response = await api.post(`/strava/activities/${activityId}/sync`, {
      challengeId
    });
    return response.data;
  } catch (error) {
    console.error('Erreur syncStravaActivity:', error);
    throw error;
  }
};

// ============================================================
// CHALLENGES API
// ============================================================

export const createChallenge = async (challengeData) => {
  try {
    const response = await api.post('/challenges', challengeData);
    return response.data;
  } catch (error) {
    console.error('Erreur createChallenge:', error);
    throw error;
  }
};

export const getChallengesByClub = async (clubId) => {
  try {
    const response = await api.get(`/challenges/club/${clubId}`);
    return response.data;
  } catch (error) {
    console.error('Erreur getChallengesByClub:', error);
    throw error;
  }
};

export const getChallengeById = async (id) => {
  try {
    const response = await api.get(`/challenges/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erreur getChallengeById:', error);
    throw error;
  }
};

export const joinChallenge = async (id) => {
  try {
    const response = await api.post(`/challenges/${id}/join`);
    return response.data;
  } catch (error) {
    console.error('Erreur joinChallenge:', error);
    throw error;
  }
};

export const leaveChallenge = async (id) => {
  try {
    const response = await api.post(`/challenges/${id}/leave`);
    return response.data;
  } catch (error) {
    console.error('Erreur leaveChallenge:', error);
    throw error;
  }
};

export const getLeaderboard = async (id) => {
  try {
    const response = await api.get(`/challenges/${id}/leaderboard`);
    return response.data;
  } catch (error) {
    console.error('Erreur getLeaderboard:', error);
    throw error;
  }
};

export const getClubLeaderboard = async (clubId) => {
  try {
    const response = await api.get(`/challenges/club/${clubId}/leaderboard`);
    return response.data;
  } catch (error) {
    console.error('Erreur getClubLeaderboard:', error);
    throw error;
  }
};

export const getGlobalLeaderboard = async () => {
  try {
    const response = await api.get('/users/global-leaderboard');
    return response.data;
  } catch (error) {
    console.error('Erreur getGlobalLeaderboard:', error);
    throw error;
  }
};

export const deleteChallenge = async (id) => {
  try {
    const response = await api.delete(`/challenges/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erreur deleteChallenge:', error);
    throw error;
  }
};

export const autoSyncToChallenge = async (challengeId) => {
  try {
    const response = await api.post(`/strava/challenges/${challengeId}/auto-sync`);
    return response.data;
  } catch (error) {
    console.error('Erreur autoSyncToChallenge:', error);
    throw error;
  }
};

export const updateMultiplicateur = async (challengeId, participantId, multiplicateur) => {
  try {
    const response = await api.patch(
      `/challenges/${challengeId}/participants/${participantId}/multiplicateur`,
      { multiplicateur }
    );
    return response.data;
  } catch (error) {
    console.error('Erreur updateMultiplicateur:', error);
    throw error;
  }
};

export const updateMultiplicateurs = async (challengeId, multiplicateurs) => {
  try {
    const response = await api.patch(
      `/challenges/${challengeId}/multiplicateurs`,
      { multiplicateurs }
    );
    return response.data;
  } catch (error) {
    console.error('Erreur updateMultiplicateurs:', error);
    throw error;
  }
};

export const completeChallenge = async (id) => {
  try {
    const response = await api.post(`/challenges/${id}/complete`);
    return response.data;
  } catch (error) {
    console.error('Erreur completeChallenge:', error);
    throw error;
  }
};

export const getChallengeResults = async (id) => {
  try {
    const response = await api.get(`/challenges/${id}/results`);
    return response.data;
  } catch (error) {
    console.error('Erreur getChallengeResults:', error);
    throw error;
  }
};

export const inviteUserToClub = async (clubId, userId) => {
  try {
    const response = await api.post(`/clubs/${clubId}/invite`, { userId });
    return response.data;
  } catch (error) {
    console.error('Erreur inviteUserToClub:', error);
    throw error;
  }
};

export const acceptInvitation = async (clubId) => {
  try {
    const response = await api.post(`/clubs/${clubId}/accept-invitation`);
    return response.data;
  } catch (error) {
    console.error('Erreur acceptInvitation:', error);
    throw error;
  }
};

export const declineInvitation = async (clubId) => {
  try {
    const response = await api.post(`/clubs/${clubId}/decline-invitation`);
    return response.data;
  } catch (error) {
    console.error('Erreur declineInvitation:', error);
    throw error;
  }
};

export const getClubInvitations = async (clubId) => {
  try {
    const response = await api.get(`/clubs/${clubId}/invitations`);
    return response.data;
  } catch (error) {
    console.error('Erreur getClubInvitations:', error);
    throw error;
  }
};

// ============================================================
// FRIENDS API
// ============================================================

// Rechercher des utilisateurs pour ajouter comme amis
export const searchUsersForFriends = async (query) => {
  try {
    const response = await api.get(`/friends/search?q=${encodeURIComponent(query)}`);
    return response.data;
  } catch (error) {
    console.error('Erreur searchUsersForFriends:', error);
    throw error;
  }
};

export const getFriendRecommendations = async () => {
  try {
    const response = await api.get('/friends/recommendations');
    return response.data;
  } catch (error) {
    console.error('Erreur getFriendRecommendations:', error);
    throw error;
  }
};

// Envoyer une demande d'ami
export const sendFriendRequest = async (userId) => {
  try {
    const response = await api.post(`/friends/${userId}/request`);
    return response.data;
  } catch (error) {
    console.error('Erreur sendFriendRequest:', error);
    throw error;
  }
};

// Accepter une demande d'ami
export const acceptFriendRequest = async (userId) => {
  try {
    const response = await api.post(`/friends/${userId}/accept`);
    return response.data;
  } catch (error) {
    console.error('Erreur acceptFriendRequest:', error);
    throw error;
  }
};

// Refuser une demande d'ami
export const rejectFriendRequest = async (userId) => {
  try {
    const response = await api.post(`/friends/${userId}/reject`);
    return response.data;
  } catch (error) {
    console.error('Erreur rejectFriendRequest:', error);
    throw error;
  }
};

// Obtenir la liste de mes amis
export const getFriends = async () => {
  try {
    const response = await api.get('/friends/list');
    return response.data;
  } catch (error) {
    console.error('Erreur getFriends:', error);
    throw error;
  }
};

// Obtenir les demandes d'amis reçues
export const getFriendRequests = async () => {
  try {
    const response = await api.get('/friends/requests');
    return response.data;
  } catch (error) {
    console.error('Erreur getFriendRequests:', error);
    throw error;
  }
};

export default api;